<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in" />
    <router-view name="header" />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <router-view name="footer" />
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import 'sweetalert2/dist/sweetalert2.css';
import 'vue-notifyjs/themes/default.css';
import '../node_modules/@syncfusion/ej2-base/styles/material.css';
import '../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css';
import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';

export default {};
</script>
<style lang="scss">
// #background-img {
//   opacity: .7;
//   padding: 0;
//   margin: 0;
//   position: fixed;
// }
.main-panel {
  background-color: rgba(102, 177, 255, 1);
}
</style>
